import React, { useState } from 'react';
import './index.css';
import PasswordGate from './components/PasswordGate';
import IntakeForm from './components/IntakeForm';
import Confirmation from './components/Confirmation';

const APP_PASSWORD = process.env.REACT_APP_INTAKE_PASSWORD || 'crafted2024';

export default function App() {
  const [authed, setAuthed] = useState(false);
  const [submitted, setSubmitted] = useState(null); // { dealId, dealName }

  if (!authed) return <PasswordGate password={APP_PASSWORD} onSuccess={() => setAuthed(true)} />;
  if (submitted) return <Confirmation data={submitted} onNew={() => setSubmitted(null)} />;
  return <IntakeForm onSubmit={(result) => setSubmitted(result)} />;
}
